import { render, staticRenderFns } from "./CompanyEmail.vue?vue&type=template&id=8bcff4ee&scoped=true&"
import script from "./CompanyEmail.vue?vue&type=script&lang=js&"
export * from "./CompanyEmail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEmail.vue?vue&type=style&index=0&id=8bcff4ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcff4ee",
  null
  
)

export default component.exports